import React from 'react';
import { Tooltip, IconButton, Grid, Box, Card, CardContent, Stack, Typography, Button, FormGroup, FormControlLabel, Checkbox, Slider } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { D, C } from '../include';
import dayjs from 'dayjs';
import { Wc, ElderlyWoman, MedicalInformation, Person } from '@mui/icons-material';
import { StatCard } from './StatCard';
import { BarChartGroupedCard } from './BarChartGroupedCard';
import { BarChartCard } from './BarChartCard';
import { MapCard } from './MapCard';




export class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    var start = dayjs();
    var end = start.subtract(1,'month'); 
    this.state = {
      dataini: end.format('YYYY-MM-DD'),
      datafim: start.format('YYYY-MM-DD'),
      sexo: [-1,1,2],
      idade: [18,80],
      procedimento: ['null'], //1st time front is rendered, it will use this value to avoid <empty> and causing route not found whe constructing the api call. It is replaced by '' at the backend
      doutor: ['null'], //1st time front is rendered, it will use this value to avoid <empty> and causing route not found whe constructing the api call. It is replaced by '' at the backend
      loading: true,
      showGenderConfig: false,
      showAgeConfig: false,
      showProcedureConfig: false,
      showDoctorConfig: false,
      auxList: [],
      doctor_dic: {},
      treatment_dic: {},
    };
  }

  componentDidMount = () => {
    this.props.api
      .get('/Doctors')
      .then((r) => {
        var list = {};
        var doctor_indexes = [];
        for(var row in r.doctors){
          list[ r.doctors[row]["id"] ]= r.doctors[row]["name"];
          doctor_indexes.push(r.doctors[row]["id"]);          
        }
        this.setState({
          doctor_dic: list,
          doutor: doctor_indexes,
        });
      })
      .catch(() => {
        this.props.alert('Ocorreu um erro ao buscar os registros de profissonais de saúde');
      });
      
    this.props.api
      .get('/TreatmentsBrief')
      .then((r) => {
        var list = {};
        var procedimento_indexes = [];
        for(var row in r.treatments){
          list[ r.treatments[row]["id"] ]= r.treatments[row]["name"]; 
          procedimento_indexes.push(r.treatments[row]["id"]);         
        }
        this.setState({
          treatment_dic: list,
          procedimento: procedimento_indexes,
        });
      })
      .catch(() => {
        this.props.alert('Ocorreu um erro ao buscar os registros de tratamentos');
      });
      
      
    this.onChangeDate({
      dataini: this.state.dataini,
      datafim: this.state.datafim,
    });
    
  };


  
  // Necessário guardar uma referência para cada componente do dashboard para poder provocar um update forçado nos mesmo
  patientStatComponentRef = React.createRef();
  firstsessionStatComponentRef = React.createRef();
  revisionStatComponentRef = React.createRef();
  revenueStatComponentRef = React.createRef();
  teamComponentRef = React.createRef();
  genderComponentRef = React.createRef();
  ageComponentRef = React.createRef();
  civilstateComponentRef = React.createRef();
  mapComponentRef = React.createRef();

  // Em todos estes onChange, seta as variáveis de estado. Como os componentes recebem os dados por propriedade do componente, que é imutável, preciso forçar um update chamando a função .current.updateStates 
  onChangeDate = (params) => {
    this.setState({ dataini: params.dataini, datafim: params.datafim });
    
    this.patientStatComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.firstsessionStatComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.revisionStatComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.revenueStatComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.teamComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.genderComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.ageComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.civilstateComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
    this.mapComponentRef.current.updateStates(params.dataini, params.datafim, this.state.sexo, this.state.idade, this.state.procedimento, this.state.doutor);
  };  
  
  onChangeGender = () => {
    this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: false, sexo: structuredClone(this.state.auxList)});
    
    this.patientStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.firstsessionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.revisionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.revenueStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.teamComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.genderComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.ageComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.civilstateComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
    this.mapComponentRef.current.updateStates(this.state.dataini, this.state.datafim, structuredClone(this.state.auxList), this.state.idade, this.state.procedimento, this.state.doutor);
  }

  onChangeAge = () => {
    this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: false, idade: structuredClone(this.state.auxList)});
    
    this.patientStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.firstsessionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.revisionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.revenueStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.teamComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.genderComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.ageComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.civilstateComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
    this.mapComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, structuredClone(this.state.auxList), this.state.procedimento, this.state.doutor);
  }
  
  onChangeProcedure = () => {
    this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: false, procedimento: structuredClone(this.state.auxList)});
    
    this.patientStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.firstsessionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.revisionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.revenueStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.teamComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.genderComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.ageComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.civilstateComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
    this.mapComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, structuredClone(this.state.auxList), this.state.doutor);
  }
  
  onChangeDoctor = () => {
    this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: false, doutor: structuredClone(this.state.auxList)});
    
    this.patientStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.firstsessionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.revisionStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.revenueStatComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.teamComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.genderComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.ageComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.civilstateComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
    this.mapComponentRef.current.updateStates(this.state.dataini, this.state.datafim, this.state.sexo, this.state.idade, this.state.procedimento, structuredClone(this.state.auxList));
  }












  

  
  



  render() {
    return (
      <D className="col e aF scD" style={{ padding: '2rem',  backgroundColor: '#f9fbfd' }}>
        {/******************** 1a Parte com os componentes de filtragem **************************/}
        <D className="row w">             
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Data inicial"
              format="DD/MM/YYYY"
              value={dayjs(this.state.dataini)}
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
              onChange={(newValue) =>
                this.onChangeDate({
                  dataini: newValue.format('YYYY-MM-DD'),
                  datafim: this.state.datafim,
                })
              }
            />
          </LocalizationProvider>
          <D size="1rem" />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Data final"
              format="DD/MM/YYYY"
              value={dayjs(this.state.datafim)}
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
              onChange={(newValue) =>
                this.onChangeDate({
                  dataini: this.state.dataini,
                  datafim: newValue.format('YYYY-MM-DD'),
                })
              }
            />
          </LocalizationProvider>
          <D size="1rem" />
          <Tooltip title="Gênero" arrow style={{padding: '0rem', margin: '0rem'}}>
            <IconButton onClick={() => this.setState({showGenderConfig: !this.state.showGenderConfig, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: false, auxList: structuredClone(this.state.sexo)}) }>
              <Wc />
            </IconButton>
          </Tooltip>
          <D size="1rem" />
          <Tooltip title="Idade" arrow style={{padding: '0rem', margin: '0rem'}}>
            <IconButton onClick={() => this.setState({showGenderConfig: false, showAgeConfig: !this.state.showAgeConfig, showProcedureConfig: false, showDoctorConfig: false, auxList: structuredClone(this.state.idade)}) }>
              <ElderlyWoman />
            </IconButton>
          </Tooltip>
          <D size="1rem" />
          <Tooltip title="Tratamento" arrow style={{padding: '0rem', margin: '0rem'}}>
            <IconButton onClick={() => this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: !this.state.showProcedureConfig, showDoctorConfig: false, auxList: structuredClone(this.state.procedimento)})  }>
              <MedicalInformation />
            </IconButton>
          </Tooltip>
          <D size="1rem" />
          <Tooltip title="Profissional de Saúde" arrow style={{padding: '0rem', margin: '0rem'}}>
            <IconButton onClick={() => this.setState({showGenderConfig: false, showAgeConfig: false, showProcedureConfig: false, showDoctorConfig: !this.state.showDoctorConfig, auxList: structuredClone(this.state.doutor)}) }>
              <Person />
            </IconButton>
          </Tooltip>
        </D>
        <D h="1rem" />
        
        {/******************** 2a Parte com os cards de filtro em que é feito um show/hide **************************/}
        {this.state.showGenderConfig && 
          <>
            <D>
              <Card sx={{ height: '100%', flexGrow: 1 }} elevation={4}>
                <CardContent>
                  <Typography gutterBottom sx={{ color: 'text.secondary' }}>Filtro de Gênero </Typography>
                  <Stack direction='column' sx={{ justifyContent: 'space-between', flexGrow: '1', gap: '0px' }} >
                    <FormGroup>
                      {Object.keys(C.GenderType).map(key => {
                        return <FormControlLabel 
                                 key={'gender'+key} 
                                 control={<Checkbox 
                                            onChange={e => { 
                                              var aux = this.state.auxList;
                                              if(e.target.checked)
                                                aux.push(parseInt(key));
                                              else
                                                aux.splice( aux.indexOf(parseInt(key)) ,1 );
                                              this.setState({auxList: aux}); 
                                            }}
                                          />} 
                                 label={C.GenderType[key]} 
                                 checked={this.state.auxList.includes(parseInt(key))}
                                />
                      })
                      }                    
                    </FormGroup>                    
                    <Button size="small" sx={{ padding: '0rem' }} onClick={() => this.onChangeGender()} >Atualizar</Button>
                  </Stack>
                </CardContent>
              </Card>
            </D>
            <D h="1rem" />
          </>
        }
        {this.state.showAgeConfig && 
          <>
            <D>
              <Card sx={{ height: '100%', flexGrow: 1 }} elevation={4}>
                <CardContent>
                  <Typography gutterBottom sx={{ color: 'text.secondary' }}>Filtro de Idade </Typography>
                  <Stack direction='column' sx={{ justifyContent: 'space-between', flexGrow: '1', gap: '0px' }} >
                    <D h="1.5rem" />
                    <Box sx={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
                    <Slider
                      value={this.state.auxList}
                      onChange={ (event, newValue) => this.setState({auxList: newValue}) }
                      valueLabelDisplay="on"
                      min={0}
                      max={120}
                    />
                    </Box>
                    <Button size="small" sx={{ padding: '0rem' }} onClick={() => this.onChangeAge()} >Atualizar</Button>
                  </Stack>
                </CardContent>
              </Card>
            </D>
            <D h="1rem" />
          </>
        }
        {this.state.showProcedureConfig && 
          <>
            <D>
              <Card sx={{ height: '100%', flexGrow: 1 }} elevation={4}>
                <CardContent>
                  <Typography gutterBottom sx={{ color: 'text.secondary' }}>Filtro de Tratamento </Typography>
                  <Stack direction='column' sx={{ justifyContent: 'space-between', flexGrow: '1', gap: '0px' }} >
                    <FormGroup>
                      {Object.keys(this.state.treatment_dic).map(key => {
                        return <FormControlLabel 
                                 key={'treatment'+key} 
                                 control={<Checkbox 
                                            onChange={e => { 
                                              var aux = this.state.auxList;
                                              if(e.target.checked)
                                                aux.push(parseInt(key));
                                              else
                                                aux.splice( aux.indexOf(parseInt(key)) ,1 );
                                              this.setState({auxList: aux}); 
                                            }}
                                          />} 
                                 label={this.state.treatment_dic[key]} 
                                 checked={this.state.auxList.includes(parseInt(key))}
                                />
                      })
                      }                    
                    </FormGroup>                    
                    <Button size="small" sx={{ padding: '0rem' }} onClick={() => this.onChangeProcedure()} >Atualizar</Button>
                  </Stack>
                </CardContent>
              </Card>
            </D>
            <D h="1rem" />
          </>
        }     
        {this.state.showDoctorConfig && 
          <>
            <D>
              <Card sx={{ height: '100%', flexGrow: 1 }} elevation={4}>
                <CardContent>
                  <Typography gutterBottom sx={{ color: 'text.secondary' }}>Filtro de Profissional de Saúde </Typography>
                  <Stack direction='column' sx={{ justifyContent: 'space-between', flexGrow: '1', gap: '0px' }} >
                    <FormGroup>
                      {Object.keys(this.state.doctor_dic).map(key => {
                        return <FormControlLabel 
                                 key={'doctor'+key} 
                                 control={<Checkbox 
                                            onChange={e => { 
                                              var aux = this.state.auxList;
                                              if(e.target.checked)
                                                aux.push(parseInt(key));
                                              else
                                                aux.splice( aux.indexOf(parseInt(key)) ,1 );
                                              this.setState({auxList: aux}); 
                                            }}
                                          />} 
                                 label={this.state.doctor_dic[key]} 
                                 checked={this.state.auxList.includes(parseInt(key))}
                                />
                      })
                      }                    
                    </FormGroup>                    
                    <Button size="small" sx={{ padding: '0rem' }} onClick={() => this.onChangeDoctor()} >Atualizar</Button>
                  </Stack>
                </CardContent>
              </Card>
            </D>
            <D h="1rem" />
          </>
        }          
        
        
        
        
        
        {/******************** 3a Parte com os cards de estatística **************************/}
        <Grid container spacing={2} columns={12} > 
          <Grid item key='paciente123' xs={12} sm={6} lg={3} >
            <StatCard ref={this.patientStatComponentRef} context='paciente' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='1asessao123' xs={12} sm={6} lg={3} >
            <StatCard ref={this.firstsessionStatComponentRef} context='1asessao' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='revisao123' xs={12} sm={6} lg={3} >
            <StatCard ref={this.revisionStatComponentRef} context='revisao' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='receita123' xs={12} sm={6} lg={3} >
            <StatCard ref={this.revenueStatComponentRef} context='receita' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>

          {/******************** 4a Parte com os gráficos **************************/}

          <Grid item key='equipe123' xs={12} md={6}>
            <BarChartGroupedCard ref={this.teamComponentRef} context='equipe' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='genero123' xs={12} md={6}>
            <BarChartGroupedCard ref={this.genderComponentRef} context='genero' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='idade123' xs={12} md={6}>
            <BarChartCard ref={this.ageComponentRef} context='idade' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          <Grid item key='estadocivil123' xs={12} md={6}>
            <BarChartCard ref={this.civilstateComponentRef} context='estadocivil' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
 
        
          {/******************** 5a Parte com o mapa **************************/}
          <Grid item key='map123' xs={12} md={12}>
            <MapCard ref={this.mapComponentRef} context='tratamento' dataini={this.state.dataini} datafim={this.state.datafim} sexo={this.state.sexo} idade={this.state.idade} procedimento={this.state.procedimento} doutor={this.state.doutor} api={this.props.api} />
          </Grid>
          
        </Grid>
        
      

      </D> 
    );
  }
}
